
const RegExSearchHighlight = /[.*+?^${}()|[\]\\]/g;

export const highlightText = (searchText: string, fullText: string) => {
    const regex = new RegExp(searchText.replace(RegExSearchHighlight, '\\$&'), 'gi');
    return fullText.replace(regex, (match) => `<em>${match}</em>`);
}
